module.exports = __webpack_public_path__ + "img/focus-center.b3d53d71.png";